"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _omit = _interopRequireDefault(require("../utils/omit"));

var _controlLabel = _interopRequireDefault(require("../control-label"));

var _controlWrapper = _interopRequireDefault(require("../control-wrapper"));

var _popover = _interopRequireDefault(require("../popover"));

var _icon = _interopRequireDefault(require("../icon"));

var _getWindow = _interopRequireDefault(require("../utils/get-window"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const propNames = ['id', 'value', 'onChange', 'type', 'label', 'noAuto', 'optional', 'aside', 'validationError', 'errorStyle', 'errorTooltipTheme', 'errorTooltipBackgroundColor', 'themeControlInput', 'themeControlWrapper', 'themeLabel', // Passed when used with the Form component
'initialValue', 'validator'];

class ControlText extends _react.default.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "inputElement", null);

    _defineProperty(this, "errorElement", null);

    _defineProperty(this, "onChange", e => {
      return this.props.onChange(e.target.value, this.props.id);
    });

    _defineProperty(this, "setInputElement", el => {
      this.inputElement = el;
    });

    _defineProperty(this, "setErrorElement", el => {
      this.errorElement = el;
    });

    _defineProperty(this, "getErrorElement", () => {
      return this.errorElement;
    });

    _defineProperty(this, "onErrorClick", () => {
      if (this.inputElement) this.inputElement.select();
    });

    _defineProperty(this, "onFocus", () => {
      this.setState({
        popoverOpen: true
      });
    });

    _defineProperty(this, "onBlur", () => {
      this.setState({
        popoverOpen: false
      });
    });

    _defineProperty(this, "isActive", () => {
      return (0, _getWindow.default)().document.activeElement === this.inputElement || (0, _getWindow.default)().document.activeElement === this.errorElement;
    });

    _defineProperty(this, "onContainerMouseOver", () => {
      if (this.isActive()) return;
      this.setState({
        popoverOpen: true
      });
    });

    _defineProperty(this, "onContainerMouseOut", () => {
      if (this.isActive()) return;
      this.setState({
        popoverOpen: false
      });
    });

    _defineProperty(this, "renderLabel", () => {
      const {
        id,
        label,
        optional,
        aside,
        themeLabel
      } = this.props;
      return /*#__PURE__*/_react.default.createElement(_controlLabel.default, {
        text: label,
        id: id,
        aside: aside,
        optional: optional,
        themeLabel: themeLabel
      });
    });

    _defineProperty(this, "renderPopover", () => {
      const {
        validationError,
        errorTooltipTheme,
        errorTooltipBackgroundColor
      } = this.props;
      const popoverProps = {
        getAnchorElement: this.getErrorElement,
        placement: 'top',
        receiveFocus: false,
        accessibleTitle: 'Validation error'
      };

      if (errorTooltipBackgroundColor) {
        popoverProps.backgroundColor = errorTooltipBackgroundColor;
      }

      if (errorTooltipTheme) {
        popoverProps.themePopover = errorTooltipTheme;
      }

      return /*#__PURE__*/_react.default.createElement(_popover.default, popoverProps, validationError);
    });

    this.state = {
      popoverOpen: false
    };
  }

  render() {
    const extraProps = (0, _omit.default)(this.props, propNames);
    const {
      id,
      value,
      label,
      type,
      optional,
      validationError,
      errorStyle,
      noAuto,
      themeControlInput,
      themeControlWrapper
    } = this.props;
    const {
      popoverOpen
    } = this.state;
    const inputProps = {
      id,
      name: id,
      onChange: this.onChange,
      value,
      type,
      className: themeControlInput,
      'aria-required': optional ? false : true,
      'data-test': `${id}-input`
    };

    if (noAuto) {
      inputProps.autoCapitalize = 'none';
      inputProps.autoCorrect = 'off';
      inputProps.spellCheck = false;
    }

    if (validationError) {
      inputProps['aria-invalid'] = true;
    }

    if (validationError && errorStyle === 'inline') {
      inputProps.className = `${themeControlInput} round-l flex-child-grow`;
      inputProps.style = {
        boxShadow: 'inset 0 0 0 1px #f74e4e'
      };
    }

    const labelElement = label ? this.renderLabel() : null;
    const popover = popoverOpen ? this.renderPopover() : null;

    let control = /*#__PURE__*/_react.default.createElement("input", _extends({}, inputProps, extraProps));

    if (errorStyle === 'inline') {
      if (validationError) {
        control = /*#__PURE__*/_react.default.createElement("div", {
          onMouseOver: this.onContainerMouseOver,
          onMouseOut: this.onContainerMouseOut,
          "data-test": "control-text-container",
          className: "flex"
        }, /*#__PURE__*/_react.default.createElement("input", _extends({
          ref: this.setInputElement,
          onFocus: this.onFocus,
          onBlur: this.onBlur
        }, inputProps, extraProps)), /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          ref: this.setErrorElement,
          onClick: this.onErrorClick,
          role: "alert",
          "aria-label": validationError,
          className: "bg-red color-white round-r px6"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "flex flex--center-cross flex--center-main"
        }, /*#__PURE__*/_react.default.createElement(_icon.default, {
          name: "alert",
          themeIcon: "cursor-pointer"
        }))));
      }

      return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
        themeControlWrapper: themeControlWrapper,
        id: id
      }, labelElement, control, popover);
    }

    return /*#__PURE__*/_react.default.createElement(_controlWrapper.default, {
      themeControlWrapper: themeControlWrapper,
      id: id,
      validationError: validationError
    }, labelElement, control);
  }

}

exports.default = ControlText;

_defineProperty(ControlText, "propTypes", {
  /** Unique id for this control. Required if you want a `label`. */
  id: _propTypes.default.string.isRequired,

  /**
   * Invoked when the control's value changes.
   * Passed two arguments:
   *
   * - `value` the current value of the input passes as a string
   * - The `id` prop.
   */
  onChange: _propTypes.default.func.isRequired,

  /** The control's value. Can be an empty string to indicate no value. */
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /** Type attribute to override the existing default of 'text' */
  type: _propTypes.default.string,

  /** Label for the control. */
  label: _propTypes.default.string,

  /** Enable/Disable browser enabled autocorrect or spelling suggestions from the element. */
  noAuto: _propTypes.default.bool,

  /** If provided, "(optional)" is appended to the value of the legend element. */
  optional: _propTypes.default.bool,

  /** Additional content inserted alongside the label element. */
  aside: _propTypes.default.node,

  /** If provided, the value of this propery displays as an error message. */
  validationError: _propTypes.default.node,

  /**
   * Sets the style of the error message. There are two options:
   *
   * - `default` the standard presentation control components display an error
   *   message: beneath the input.
   * - `inline` An error indicator is displayed to the right of the element
   *   with the value of `validationError` prop displayed in a tooltip.
   */
  errorStyle: _propTypes.default.oneOf(['default', 'inline']),

  /** Background color of the error tooltip when `errorStyle: "inline"` is set. */
  errorTooltipBackgroundColor: _propTypes.default.string,

  /** Classes to style the error tooltip container. */
  errorTooltipTheme: _propTypes.default.string,

  /** Classes to apply to the input element */
  themeControlInput: _propTypes.default.string,

  /** Classes to apply to the control wrapper */
  themeControlWrapper: _propTypes.default.string,

  /** classes to apply to the label element */
  themeLabel: _propTypes.default.string
});

_defineProperty(ControlText, "defaultProps", {
  value: '',
  type: 'text',
  optional: false,
  noAuto: false,
  errorStyle: 'default',
  themeControlInput: 'input'
});